import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Vite glob: loads all JSON files from src/locales/ automatically.
// To add a new language, simply create a new {lang}.json file.
const localeModules = import.meta.glob('./locales/*.json', { eager: true })

const resources: Record<string, { translation: Record<string, string> }> = {}
for (const path in localeModules) {
  // path e.g. './locales/de.json' → lang = 'de'
  const lang = path.replace('./locales/', '').replace('.json', '')
  resources[lang] = { translation: (localeModules[path] as { default: Record<string, string> }).default }
}

// Derive supported languages from the discovered locale files
export const SUPPORTED_LANGUAGES = Object.keys(resources) as Array<'de' | 'en' | 'fr'>

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de',
    fallbackLng: 'de',
    interpolation: { escapeValue: false },
  })

export default i18n
